module.exports = __webpack_public_path__ + "img/huayang2.5bb56a3f.png";